module.exports = __webpack_public_path__ + "img/airplanes.e9d2365d.jpg";